import {
  IMG_FOOTER_ICON_FACEBOOK,
  IMG_FOOTER_ICON_INSTA,
  IMG_FOOTER_ICON_YOUTUBE,
} from '../../constants/home.constants'

const SocialButtons = ({ buttonClassName, onButtonClick }) => {
  return (
    <div className="flex gap-x-12 h-40">
      <button className="min-w-40" onClick={() => onButtonClick('유튜브', null)}>
        <a href="https://www.youtube.com/@ringleofficial" target="_blank" rel="noreferrer">
          <img src={IMG_FOOTER_ICON_YOUTUBE} width={40} height={40} alt="youtube-logo" className={buttonClassName} />
        </a>
      </button>
      <button className="min-w-40" onClick={() => onButtonClick('인스타그램', null)}>
        <a href="https://www.instagram.com/ringleedu/" target="_blank" rel="noreferrer">
          <img src={IMG_FOOTER_ICON_INSTA} width={40} height={40} alt="insta-logo" className={buttonClassName} />
        </a>
      </button>
      <button className="min-w-40" onClick={() => onButtonClick('페이스북', null)}>
        <a href="https://www.facebook.com/ringleedu" target="_blank" rel="noreferrer">
          <img src={IMG_FOOTER_ICON_FACEBOOK} width={40} height={40} alt="facebook-logo" className={buttonClassName} />
        </a>
      </button>
    </div>
  )
}

export default SocialButtons
